
import React from 'react'
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    Col,
    Modal,
    ModalHeader, Row
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

import { trigger } from '../../events/customEvents'

const PdfViewerModal = ({ showPdfViewerModal, base64String }) =>
{
    const { t } = useTranslation()

    const handleCancelModal = () =>
    {
        trigger('pdfViewerModalClosed', {  })
    }

    const base64toBlob = (data) =>
    {
        // Cut the prefix `data:application/pdf;base64` from the raw base 64
        const base64WithoutPrefix = data.substr(`data:application/pdf;base64,`.length);

        const bytes = atob(base64WithoutPrefix);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--)
        {
            out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], { type: 'application/pdf' });
    }

    const getFileUrl = () =>
    {
        let fileUrl = undefined
        if (base64String !== undefined)
        {
            fileUrl = URL.createObjectURL(base64toBlob(base64String))
        }
        return fileUrl
    }

    return (
        <>
            <Modal
                className="modal-dialog-centered"
                size="lg"
                fullscreen="md"
                isOpen={ showPdfViewerModal }
            >
                <ModalHeader className="modal-banner">
                    <h3 className="modal-banner-title">{ 'Confirmation of Sale' }</h3>
                    <button
                        aria-label="Close"
                        className="close modal-close-button"
                        type="button"
                        onClick={ handleCancelModal }
                    >
                        <span aria-hidden={true}>x</span>
                    </button>
                </ModalHeader>
                <div className="modal-body p-0">
                    <Card className="bg-secondary border-0 mb-0">
                        <CardBody
                            styles={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
                        >
                            <Document file={base64String}>
                                <Page pageNumber={1} />
                            </Document>
                        </CardBody>
                        <CardFooter>
                            <Row>
                                <Col md={12}>
                                    <Button color="default" type="button" className="btn-block" onClick={ handleCancelModal }>
                                        { t('Modals.PlaceMemberBid.Cancel') }
                                    </Button>
                                </Col>
                            </Row>
                        </CardFooter>
                    </Card>
                </div>
            </Modal>
        </>
    )
}

export default PdfViewerModal
